module.exports = __webpack_public_path__ + "img/20.ee704397.gif";